import { serviceImageActionsFactory } from '../factories/serviceImageActionsFactory.ts';
import useAddChargingServiceImage from './useAddChargingServiceImage.ts';
import useRemoveChargingServiceImage from './useRemoveChargingServiceImage.ts';
import useChargingServiceImages from './useChargingServiceImages.ts';

export const useChargingServiceImageActions = serviceImageActionsFactory({
  useAdd: useAddChargingServiceImage,
  useRemove: useRemoveChargingServiceImage,
  useImages: useChargingServiceImages,
  queryKey: (id) => ['chargingServices', id],
});
